import axios from 'axios';
import DialogManager from './DialogManager';

export default async function invoiceAndPrintRestitution(id, type) {
    let invoiceResponse, restitutionResponse;

    try {
        invoiceResponse = await axios.post('/financial/billables/invoice', {
            id,
            revenue_resource_type: type,
        });
    } catch (err) {
        return DialogManager.alert(err.response?.data?.message || this.$t('base.errors.server'));
    }

    try {
        restitutionResponse = await axios.get('/financial/invoices/print-restitution', {
            params: { id: invoiceResponse.data.ids },
        });
        return restitutionResponse.data;
    } catch (err) {
        return DialogManager.alert(err.response?.data?.message || this.$t('base.errors.server'));
    }
}
